import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import Reviews from '../../components/Reviews/Reviews';
import { errorTextSx } from './listingPageStyles';
import ListingSection from './ListingSection';
import ListingSectionItem from './ListingSectionItem';

/**
 * Reviews section of a Listing.
 * @param {object} props - component props
 * @param {Array} props.reviews - reviews to show
 * @param {Error|null} props.fetchReviewsError - error object when fetching reviews
 * @param {Function} props.getTranslation - function to translate strings
 * @returns {React.JSX.Element|null}
 */

const SectionReviewsComponent = ({
  fetchReviewsError = null,
  getTranslation,
  reviews,
  reviewsRef,
}) => {
  if (reviews.length === 0) {
    return null;
  }

  const reviewsError = (
    <Box component="h2" sx={errorTextSx}>
      <FormattedMessage id="ListingPage.reviewsError" />
    </Box>
  );

  return (
    <ListingSection ref={reviewsRef}>
      <ListingSectionItem params={{ size: { lg: 12 } }}>
        <Typography
          component="h3"
          sx={{ textAlign: { xs: 'center', sm: 'left' }, width: '100%' }}
          variant="h4"
        >
          <FormattedMessage id="ListingPage.reviewsHeading" values={{ count: reviews.length }} />
        </Typography>
      </ListingSectionItem>
      <ListingSectionItem params={{ size: { lg: 12 } }}>
        {fetchReviewsError ? reviewsError : null}
        <Reviews getTranslation={getTranslation} reviews={reviews} />
      </ListingSectionItem>
    </ListingSection>
  );
};

SectionReviewsComponent.displayName = 'SectionReviews';

const SectionReviews = memo(SectionReviewsComponent);

export default SectionReviews;
